import {useParams} from 'react-router-dom';
export default function useDropTypeFromPath() {
  const params: {droptype: string} = useParams();
  return params.droptype;
}
